import PaymentFlow from "./Pay";
import {
  PRCancelled,
  PRConfirmDetails,
  PRChooseMethod,
  PRConfirmBankPayment,
  PRPaymentFailed,
  PRProcessing,
  PRSuccess,
  PRSelectInvoices,
  PRPayByBank,
  PRPayByCard,
  PRPayByBnpl,
} from "./sub-pages";
import RouterErrorBoundary from "../RouterErrorBoundary";

const routes = {
  // Amount/invoice confirmation
  base: <PRConfirmDetails />,
  selectinvoices: <PRSelectInvoices />,

  // Payment method selection
  paymentmethod: <PRChooseMethod />,
  paybybank: <PRPayByBank />,
  paybycard: <PRPayByCard />,
  paybybnpl: <PRPayByBnpl />,
  confirmpaybybank: <PRConfirmBankPayment />,

  // End state screens
  success: <PRSuccess />,
  cancelled: <PRCancelled />,
  processing: <PRProcessing />,
  paymentfailed: <PRPaymentFailed />,
};

export const getPaymentFlowRoutes = ({ flowId, getDataFunction, routeIds }) => {
  return {
    path: `/${flowId}/:id`,
    element: <PaymentFlow flowId={flowId} getDataFunction={getDataFunction} />,
    errorElement: <RouterErrorBoundary />,
    children: ["base", ...routeIds].map((routeId) => ({
      id: `${flowId}-${routeId}`,
      ...(routeId === "base" ? { index: true } : { path: routeId }),
      element: routes[routeId],
    })),
  };
};
